import PropTypes from 'prop-types'
import { FormattedMessage, useIntl, defineMessages } from 'react-intl'
import Card from '../shared/Card'
import IconBenefit from './IconBenefit'
import styles from './WhyDiveWithPadiCard.module.scss'

const msgs = defineMessages({
  lowestPriceTitle: {
    id: 'why_padi.lowest_price_title',
    defaultMessage: 'LOWEST PRICE GUARANTEE',
  },
  lowestPriceDesc: {
    id: 'why_padi.lowest_price_desc',
    defaultMessage: "We'll match any price and give you a voucher worth $50 USD.",
  },
  supportTitle: {
    id: 'why_padi.support_title',
    defaultMessage: '24 HOUR SUPPORT',
  },
  supportDesc: {
    id: 'why_padi.support_desc',
    defaultMessage: 'We are here 24 hours a day, 7 days a week, 365 days a year to support you.',
  },
  cancellationTitle: {
    id: 'why_padi.cancellation_title',
    defaultMessage: 'FREE CANCELLATION',
  },
  cancellationDesc: {
    id: 'why_padi.cancellation_desc',
    defaultMessage: 'Changed your mind? No problem! Cancel within 48 hours at no cost.',
  },
  insuranceTitle: {
    id: 'why_padi.insurance_title',
    defaultMessage: 'Free DAN insurance',
  },
  insuranceDesc: {
    id: 'why_padi.insurance_desc',
    defaultMessage: 'Dive with peace of mind when you spend $2,500+ USD per person',
  },
})

const ShieldCheckIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor' width='19' height='21.818' aria-hidden='true'>
    <path fillRule='evenodd' d='M9.661 2.237a.531.531 0 01.678 0 11.947 11.947 0 007.078 2.749.5.5 0 01.479.425c.069.52.104 1.05.104 1.589 0 5.162-3.26 9.563-7.834 11.256a.48.48 0 01-.332 0C5.26 16.564 2 12.163 2 7a11.898 11.898 0 01.104-1.589.5.5 0 01.48-.425 11.947 11.947 0 007.077-2.749zm4.196 5.954a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z' clipRule='evenodd' />
  </svg>
)

const UsersIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor' width='20' height='20' aria-hidden='true'>
    <path d='M7 8a3 3 0 100-6 3 3 0 000 6zM14.5 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM1.615 16.428a1.224 1.224 0 01-.569-1.175 6.002 6.002 0 0111.908 0c.058.467-.172.92-.57 1.174A9.953 9.953 0 017 17a9.953 9.953 0 01-5.385-1.572zM14.5 16h-.106c.07-.297.088-.611.048-.933a7.47 7.47 0 00-1.588-3.755 4.502 4.502 0 015.874 2.693.818.818 0 01-.36.98A7.465 7.465 0 0114.5 16z' />
  </svg>
)

const XCircleIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor' width='20' height='20' aria-hidden='true'>
    <path fillRule='evenodd' d='M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z' clipRule='evenodd' />
  </svg>
)

const wheelIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
    <path fillRule='evenodd' clipRule='evenodd' d='M5.17111 2.1457L7.11848 4.61237C7.69601 4.46254 8.304 4.46254 8.88152 4.61237L10.8289 2.1457C9.04724 1.28477 6.95276 1.28477 5.17111 2.1457ZM13.8543 5.17111L11.3876 7.11848C11.5375 7.69601 11.5375 8.304 11.3876 8.88152L13.8543 10.8289C14.7152 9.04724 14.7152 6.95276 13.8543 5.17111ZM10.8289 13.8543L8.88152 11.3876C8.304 11.5375 7.69601 11.5375 7.11848 11.3876L5.17111 13.8543C6.95276 14.7152 9.04724 14.7152 10.8289 13.8543ZM2.1457 10.8289L4.61237 8.88152C4.46254 8.304 4.46254 7.69601 4.61237 7.11848L2.1457 5.17111C1.28477 6.95276 1.28477 9.04724 2.1457 10.8289ZM3.63091 1.29667C6.27818 -0.432225 9.72183 -0.432224 12.3691 1.29667C12.8253 1.59461 13.2573 1.94356 13.6569 2.34315C14.0564 2.74273 14.4054 3.17471 14.7033 3.63091C16.4322 6.27817 16.4322 9.72183 14.7033 12.3691C14.4054 12.8253 14.0564 13.2573 13.6569 13.6569C13.2573 14.0564 12.8253 14.4054 12.3691 14.7033C9.72183 16.4322 6.27818 16.4322 3.63091 14.7033C3.1747 14.4054 2.74273 14.0564 2.34315 13.6569C1.94356 13.2573 1.59461 12.8253 1.29667 12.3691C-0.432225 9.72183 -0.432224 6.27818 1.29667 3.63091C1.59461 3.17471 1.94356 2.74273 2.34315 2.34315C2.74273 1.94356 3.17471 1.59461 3.63091 1.29667ZM8.82874 6.17897C8.30413 5.94035 7.69587 5.94035 7.17126 6.17897C6.95999 6.27506 6.76133 6.41024 6.58579 6.58579C6.41024 6.76133 6.27506 6.95999 6.17897 7.17126C5.94035 7.69587 5.94035 8.30413 6.17897 8.82874C6.27506 9.04001 6.41024 9.23867 6.58579 9.41421C6.76133 9.58976 6.95999 9.72494 7.17126 9.82103C7.69587 10.0597 8.30413 10.0597 8.82874 9.82103C9.04001 9.72494 9.23867 9.58976 9.41421 9.41421C9.58976 9.23867 9.72494 9.04001 9.82103 8.82874C10.0597 8.30413 10.0597 7.69587 9.82103 7.17126C9.72494 6.95999 9.58976 6.76133 9.41421 6.58579C9.23867 6.41024 9.04001 6.27506 8.82874 6.17897Z' fill='#0070D3' />
  </svg>
)

WhyDiveWithPadiCard.propTypes = {
  freeCancellationDays: PropTypes.number,
}

export default function WhyDiveWithPadiCard({ freeCancellationDays }) {
  const intl = useIntl()
  return (
    <Card className={styles.card}>
      <p className={styles.title}>
        <FormattedMessage
          id='why_dive_with_padi'
          defaultMessage='Why dive with PADI Travel?'
        />
      </p>
      <div className={styles.benefitsRow}>
        <IconBenefit
          icon={ShieldCheckIcon}
          title={intl.formatMessage(msgs.lowestPriceTitle)}
          description={intl.formatMessage(msgs.lowestPriceDesc)}
          termsLink='https://travel.padi.com/terms/'
        />
        <IconBenefit
          icon={UsersIcon}
          title={intl.formatMessage(msgs.supportTitle)}
          description={intl.formatMessage(msgs.supportDesc)}
        />
        <IconBenefit
          icon={XCircleIcon}
          title={intl.formatMessage(msgs.cancellationTitle)}
          description={intl.formatMessage(msgs.cancellationDesc)}
          termsLink='https://travel.padi.com/terms/'
        />
        <IconBenefit
          icon={wheelIcon}
          title={intl.formatMessage(msgs.insuranceTitle)}
          description={intl.formatMessage(msgs.insuranceDesc)}
          termsLink='https://travel.padi.com/terms/'
        />
      </div>
    </Card>
  )
}
